module.exports = __webpack_public_path__ + "static/media/google-play.14df6f33.png";